import dayjs from 'dayjs'
import { FC, useState } from 'react'
import Countdown from 'react-countdown'

import { RequestStatusAlias } from '@/api/models/requests/lib/requests.types'
import { DAY_WORDS, pluralization } from '@/utils/string-formatting'

type Props = {
  statusAlias: RequestStatusAlias
  desiredDateStart?: string
  desiredDateEnd?: string
}

const ContentBlockRemainingTime: FC<Props> = ({
  statusAlias,
  desiredDateStart,
  desiredDateEnd
}) => {
  const [isCompleted, setIsCompleted] = useState(false)
  if (
    statusAlias !== RequestStatusAlias.InWork ||
    !desiredDateStart ||
    !desiredDateEnd ||
    isCompleted
  ) {
    return null
  }

  const now = dayjs()
  const endDate = dayjs(desiredDateEnd)

  const hasStarted = now.isSameOrAfter(dayjs(desiredDateStart))
  const hasTimeLeft = endDate.isAfter(now)

  if (!hasStarted || !hasTimeLeft) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      <span className="whitespace-nowrap font-bold text-16">Осталось</span>
      <span className="flex items-center gap-4 font-normal text-16">
        <Countdown
          date={endDate.toDate()}
          onComplete={() => setIsCompleted(true)}
          renderer={({ days, hours, minutes }) =>
            [
              days > 0 && `${days} ${pluralization(days, DAY_WORDS)}`,
              hours > 0 && `${hours} час.`,
              `${minutes} мин.`
            ]
              .filter(Boolean)
              .join(' ')
          }
        />
      </span>
    </div>
  )
}

export default ContentBlockRemainingTime
